import React from 'react';
import { css } from '@emotion/core';
import i18n from 'i18next';
import Typography from '@material-ui/core/Typography';

import { shadowDarkStyle } from 'client/styles/common';
import { prizeStatusLabels } from 'client/components/Result/prizeList/getPrizeRedeemStatus';
import PrizeRedeemStatusLabel from 'client/components/Result/prizeList/PrizeRedeemStatusLabel';
import PrizeRedeemDeadline from 'client/components/Result/prizeList/PrizeRedeemDeadline';

function PrizeListItem({
    onClick = () => {},
    statusLabel,
    prize = {},
    prizeSettings = {},
    winnerStatus = {},
    promoInfo = {},
    showPromoInfo = false
}) {
    const { name: prizeName } = prize;
    const {
        imageUrl,
        redeemTimeType,
        fillFormEndDate,
        redeemStartDate,
        redeemEndDate,
        redeemWithinDays,
        redeemWithinDateTime, // 固定到期日
        redeemWithinMonthsLastDay, //配獎後幾個月底
        formId
    } = prizeSettings;
    const { name: promoName } = promoInfo;
    const { formAwardee, winnerCreatedAt, entryId: serialNo } = winnerStatus;
    const shouldCoverMask =
        Boolean(statusLabel) && statusLabel !== prizeStatusLabels.HAS_NOT_FILL_FORM;

    return (
        <div css={[wrapperStyle, shouldCoverMask && maskStyle]} onClick={onClick}>
            {Boolean(imageUrl) && (
                <div css={imgStyle}>
                    <img src={imageUrl} alt={prizeName} />
                </div>
            )}
            <div css={infoWrapperStyle}>
                <div css={infoStyle}>
                    <Typography variant="subtitle1" css={[css(overflowEllipsis), titleStyle]}>
                        {prizeName}
                    </Typography>
                    <PrizeRedeemDeadline
                        style={overflowEllipsis}
                        hasEnableRedeemForm={Boolean(formId)}
                        hasFillRedeemForm={formAwardee}
                        fillFormEndDate={fillFormEndDate}
                        redeemTimeType={redeemTimeType}
                        redeemStartDate={redeemStartDate}
                        redeemWithinDateTime={redeemWithinDateTime}
                        redeemWithinMonthsLastDay={redeemWithinMonthsLastDay}
                        redeemEndDate={redeemEndDate}
                        winnerCreatedAt={winnerCreatedAt}
                        redeemWithinDays={redeemWithinDays}
                    />
                    {showPromoInfo && (
                        <Typography variant="subtitle2" css={css(overflowEllipsis)}>
                            {i18n.t('label.promo_name')}
                            {promoName}
                        </Typography>
                    )}
                    <Typography variant="subtitle2" css={css(overflowEllipsis)}>
                        {i18n.t('label.serial_number')}
                        {serialNo}
                    </Typography>
                </div>
                <PrizeRedeemStatusLabel status={statusLabel} />
            </div>
        </div>
    );
}

export default PrizeListItem;

const wrapperStyle = css`
    height: 120px;
    margin-bottom: 8px;
    cursor: pointer;
    border-radius: 8px;
    display: flex;
    overflow: hidden;
    position: relative;
    ${shadowDarkStyle}
`;

const imgStyle = css`
    height: 120px;
    min-width: 120px;
    max-width: 120px;
    overflow: hidden;
    position: relative;
    > img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-width: 100%;
        max-height: 100%;
    }
`;

const overflowEllipsis = `
    display: block; /* Fallback for non-webkit */
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const titleStyle = css`
    -webkit-line-clamp: 2;
    line-height: 1.15;
`;

const infoWrapperStyle = css`
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    position: relative;
`;

const infoStyle = css`
    padding: 6px 8px;
    width: 100%;
    & > [class^='MuiTypography'] {
        margin-bottom: 2px;
    }
    & > [class^='MuiTypography']:last-child {
        margin-bottom: 0;
    }
`;

const maskStyle = css`
    &:after {
        content: ' ';
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: inherit;
        background-color: rgba(255, 255, 255, 0.8);
    }
`;
